import React from 'react';

import { TippyProps } from '@tippyjs/react';

import { omit } from '~/src/common/utils/object';

import { StyledTippy } from './layout';

const Tooltip = ({ children, ...props }: TippyProps) => {
  const p: Omit<TippyProps, 'theme' | 'children'> = omit(props, ['theme']);

  return (
    <StyledTippy {...p}>
      <span>{children}</span>
    </StyledTippy>
  );
};

export default Tooltip;
